import * as Request from '../Request';

const TenantGroup = {
  // 集团分页列表
  getGroupList: (data) => {
    return Request.post('/tenant/group/list', data);
  },
  // 添加集团
  addGroup: (data) => {
    return Request.post('/tenant/group/save', data);
  },
  // 编辑集团/节点/租户
  editGroup: (data) => {
    return Request.put('/tenant/group/update', data);
  },
  // 集团组织树
  getGroupTree: (data) => {
    return Request.get('/tenant/group/tree', data);
  },
  // 未挂接的一般租户列表（支持 fuzzy 搜索）
  getUnattached: (data) => {
    return Request.get('/tenant/group/unattached', data);
  },
  // 补充上级（原集团变为新集团的下级节点）
  addParent: (data) => {
    return Request.post('/tenant/group/parent', data);
  },
  // 新增下级（节点租户/一般租户）
  addChild: (data) => {
    return Request.post('/tenant/group/child', data);
  },
  // 查询节点/租户产品信息
  getProduct: (data) => {
    return Request.get('/tenant/group/product', data);
  },
  // 节点属性单独修改（超管账号/密码/有效期/配额/经纬度/运营状态，非空才更新）
  updateProperty: (data) => {
    return Request.put('/tenant/group/property', data);
  },
  // 修改节点启用状态
  updateState: (data) => {
    return Request.put('/tenant/group/state', data);
  },
  // 删除节点/集团（有下属时不可删除）
  delNode: (data) => {
    return Request.del('/tenant/group/node', data);
  },
  // 调整所属节点-可选上级树
  getMoveTree: (data) => {
    return Request.get('/tenant/group/move/tree', data);
  },
  // 调整所属节点（限当前集团内）
  moveNode: (data) => {
    return Request.put('/tenant/group/move', data);
  },
  // 转为一般租户（脱离集团，重新确认租户属性）
  convertTenant: (data) => {
    return Request.put('/tenant/group/convert', data);
  },
  // 操作历史分页列表（可包含下属对象）
  getLogList: (data) => {
    return Request.post('/tenant/group/log/list', data);
  },
  // 导入集团组织架构（groupId 走 query，xlsx 文件走 multipart/form-data）
  importOrgTree: (data, params) => {
    return Request.post(`/tenant/group/importOrgTree?groupId=${params.groupId}`, data);
  }
}
export default TenantGroup
